import React from "react";

const GalleryIcon = (props: any) => {
  return (
    <>
      
<svg width="30" height="31" viewBox="0 0 30 31" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M6.25 26.6462H23.75C25.1307 26.6462 26.25 25.527 26.25 24.1462V6.64624C26.25 5.26553 25.1307 4.14624 23.75 4.14624H6.25C4.86929 4.14624 3.75 5.26553 3.75 6.64624V24.1462C3.75 25.527 4.86929 26.6462 6.25 26.6462ZM6.25 26.6462L20 12.8962L26.25 19.1462M12.5 11.0212C12.5 12.0568 11.6605 12.8962 10.625 12.8962C9.58947 12.8962 8.75 12.0568 8.75 11.0212C8.75 9.98571 9.58947 9.14624 10.625 9.14624C11.6605 9.14624 12.5 9.98571 12.5 11.0212Z" stroke="#1E1E1E" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
</svg>

    </>
  );
};

export default GalleryIcon;